// import { useParams } from 'react-router-dom';
import McdoPage from "./Mcdonalds/McdoPage"
import CustomPageLayout from "../../layouts/CustomPageLayout"
// ...add more imports custom page as needed

const customPages = {
  McdoPage: McdoPage,
  // ...add more mappings as needed
}

export default function CustomPage({ custom_name }) {
  const PageComponent = customPages[custom_name]
  console.log("PageComponent:", PageComponent, "custom_name:", custom_name)

  if (PageComponent) {
    return (
      <CustomPageLayout>
        <PageComponent />
      </CustomPageLayout>
    )
  }
  return (
    <CustomPageLayout>
      <div>Custom page not found.</div>
    </CustomPageLayout>
  )
}
